<template>
  <div>
    <div class="row">
      <div class="col-md-12 col-md-offset-1">
        <div class="card card-wizard" id="wizardCard">
          <form-wizard error-color="#EB5E28" color="#1e94fd" title="Alta de Servidor Público" subtitle="">
            <div>
              <altas ref="Altas"></altas>
              <!-- <b-tabs content-class="mt-3">
                <b-tab title="Alta" active>
                  <altas ref="Altas"></altas>
                </b-tab>
                <b-tab title="Transferencias">
                  <transferencias ref="Transferencias"></transferencias>
                </b-tab>
              </b-tabs> -->
            </div>
            <button slot="next" class="d-none">Siguiente</button>
            <button slot="finish" class="d-none">Siguientes</button>
          </form-wizard>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import {
    FormWizard,
    TabContent
  } from "vue-form-wizard";
  import "vue-form-wizard/dist/vue-form-wizard.min.css";
  import Altas from "./AltaPersonal.vue";
  import Transferencias from "./SolTransferencias.vue";
  import swal from "sweetalert2";
  export default {
    data() {
      return {
        wizardModel: {}
      };
    },
    components: {
      FormWizard,
      TabContent,
      Altas,
      Transferencias
    },
    watch: {
      '$route': 'checkPermissions'
    },
    methods: {
      checkPermissions() {
        let permiso = [3];
        if (!this.getKey('permisos').some(r => permiso.includes(r))) {
          localStorage.clear();
          this.$router.push('/login');
          this.$router.go();

        }
      }
    },
    created() {
      this.checkPermissions()
    }
  };

</script>
<style>
  .vue-form-wizard .wizard-icon-circle.tab_shape {
    background-color: #9a9a9a !important;
    color: white;
  }

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Forms/Altas.vue